import ICalloutRequestedStep from './types/ICalloutRequestedStep'
import ICalloutSettings from './types/ICalloutSettings'
import CalloutStatuses from '../types/CalloutStatuses';

const createCalloutSteps = () :ICalloutRequestedStep[] =>  [
    {
        id: CalloutStatuses.dispatchedToTeam,
        name1: 'Dispatched to',
        name2: 'team'
    },
    {
        id: CalloutStatuses.teamAcknowledged,
        name1: 'Team',
        name2: 'acknowledged'
    },
    {
        id: CalloutStatuses.enRouteToDestination,
        name1: 'Team on',
        name2: 'their way'
    },
    {
        id: CalloutStatuses.teamOnSite,
        name1: 'Team',
        name2: 'on site'
    },
    {
        id: CalloutStatuses.teamDeparted,
        name1: 'Team',
        name2: 'Departed'
    },
];

const stepIconContainerSize = 82;
const topLabelHeigh = 60;
const activeCompletedColor = '#3FA052';
const etaStepId = CalloutStatuses.enRouteToDestination;

const overLoadedSettings: ICalloutSettings = {
    title: 'Overload Callout Requested',
    color: '#F4B827',
    upgradeButtonName: 'Upgrade to Incident'
}

const incidentSettings: ICalloutSettings = {
    title: 'Incident Callout Requested',
    color: '#F15454',
    upgradeButtonName: 'Downgrade to Overload'
}

export {
    createCalloutSteps,
    stepIconContainerSize,
    topLabelHeigh,
    activeCompletedColor,
    overLoadedSettings,
    incidentSettings,
    etaStepId
};